import script from "./DeliverFunction.vue?vue&type=script&setup=true&lang=js"
export * from "./DeliverFunction.vue?vue&type=script&setup=true&lang=js"

import "./DeliverFunction.vue?vue&type=style&index=0&id=43c4ff26&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43c4ff26"]])

export default __exports__